export class SuperParticipantsModel {
  public firstname?: string;
  public lastname?: string;
  public picture?: string;
  public name?: string;

  public setFirstName(nom: string): string {
    return (this.firstname = nom);
  }

  public setLastName(prenom: string): string {
    return (this.lastname = prenom);
  }

  public setName(prenomNom: string): string {
    return (this.name = prenomNom);
  }

  public setServiceName(description: string): string {
    return (this.name = description);
  }

  public setGroupName(description: string): string {
    return (this.name = description);
  }
}
